export default "__VITE_ASSET__CmKdKFXK__"